import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'

import style from './style'

const Footer = ({classes}) =>
    <div className={classes.footer} id={"footer"}>
        <img alt="" 
             className={classes.footerImg}
             id="footerImage"
             src={`${window.env.ASSETS_URL}/images/templates/logoPayway.svg`}
        />
    </div>;

export default withStyles(style)(Footer)
